import {EquipmentData, EquipmentPlain, Iso8601, SapDataDto, User} from '@hconnect/common/types'

import {TaskAssignee, TaskSource, TaskStatus} from './task.types'

export const MACHINE_SENTRY_ACTION_STATUSES = [
  TaskStatus.Pending,
  TaskStatus.Ongoing,
  TaskStatus.Done
] as const
export type MachineSentryActionStatus = (typeof MACHINE_SENTRY_ACTION_STATUSES)[number]

export enum MachineSentryActionPriority {
  Immediately = 'immediately',
  OneDay = 'oneDay',
  OneWeek = 'oneWeek',
  OneMonth = 'oneMonth'
}

export type MachineSentryProperties = {
  assignee?: string
  functionalLocation: string
  processStage: string
  sapPmWorkOrder?: string
  comment?: string
}

export type MachineSentryActionFormValues = {
  plantUpmId: string
  source: TaskSource
  status: MachineSentryActionStatus
  title: string
  equipment?: EquipmentPlain
  mainEquipment?: EquipmentData
  description: string
  dueDate?: Iso8601 | null
  priority?: MachineSentryActionPriority
  functionalLocation: string
  processStage?: string
  machineSentryProcessStage?: string
  assignees: User[]
}

export type MachineSentryActionDto = {
  id: string
  actionId: string
  plantUpmId: string
  title: string
  description: string
  status: MachineSentryActionStatus
  equipment: EquipmentData
  mainEquipment?: EquipmentData
  createdOn: Iso8601
  createdBy: string
  lastModified: Iso8601
  dueDate: Iso8601 | null
  priority?: MachineSentryActionPriority
  functionalLocation: string
  processStage?: string
  sapInfo: SapDataDto
  machineSentryProperties: MachineSentryProperties
  assignees: TaskAssignee[]
}

export type EditMachineSentryActionDto = {
  title: string
  description: string
  equipmentId?: string
  equipmentIdType?: string
  equipmentText?: string
  mainEquipmentId?: string
  mainEquipmentIdType?: string
  mainEquipmentText?: string
  status: MachineSentryActionStatus
  dueDate: Iso8601 | null
  priority?: MachineSentryActionPriority
  functionalLocation: string
  processStage?: string
  assignees: string[]
}

export type CreateMachineSentryMaintenanceNotificationActionDto = {
  workCenterId?: string
  plannerGroupId?: string
}

export type EditMachineSentryAction = EditMachineSentryActionDto & {
  id: string
  plantUpmId: string
}
